interface IUiState {
  scrolled: boolean
  announcement: boolean
}

export const useUiStore = defineStore('ui', {
  state: (): IUiState => ({
    scrolled: false,
    announcement: true,
  }),
  actions: {
    setScrolled(scrolled: boolean) {
      this.scrolled = scrolled
    },
    setShowAnnouncement(show: boolean) {
      this.announcement = show
    },
  },
  persist: true,
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUiStore, import.meta.hot))
}

export type UiStore = ReturnType<typeof useUiStore>
